import React from 'react'
import {
  Box,
  Grid,
  Chip,
  Input,
  Select,
  Checkbox,
  MenuItem,
} from '@material-ui/core'
import { Stack, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { TimePicker } from './form/DateTimePicker'
import { LocationSelector } from './form/LocationSelector'
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'

export const GalleryActivityFormField = ({
  control,
  classes,
  MenuClass,
  formProps,
  openSports,
  activityTags,
  setOpenSports,
  selectedGallery,
  activity_tag_options,
  handleActivityTagChange
}) => {

  const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060'
  }

  const sortedActivityTagOptions = activity_tag_options.sort((a, b) =>
    a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1)
  
  return (
    <Grid item xs={12}>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <GalleryFormFieldLabel label='Sports'/>
        <Typography sx={inputStyling}>
          <Controller
            name='activity_tags'
            control={control}
            render={(fieldProps) => (
              <Select
                multiple
                displayEmpty
                id='activity_tags'
                labelId='activity_tags'
                open={ openSports }
                value={ activityTags }
                fieldProps={ fieldProps }
                className={ classes.gallery_activity_form_field }
                onClick={ () => setOpenSports(true) }
                onChange={ handleActivityTagChange }
                input={ <Input id='activity_tags' /> }
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return (
                      <span className={ classes.sport }>
                        Select Activity/Sport
                      </span>
                    )
                  }
                  return (
                    <div className={ classes.chips }>
                      {selected.map((value) => (
                        <Chip
                          key={ value.id }
                          label={ value.name }
                          className={ classes.chip }
                        />
                      ))}
                    </div>
                  )
                }}
                MenuProps={ MenuClass }
              >
                {sortedActivityTagOptions.map((activity_tag_option) => (
                  <MenuItem
                    key={ activity_tag_option.value }
                    value={ activity_tag_option.original_item }
                  >
                    <Checkbox
                      name='checkedB'
                      color='primary'
                      checked={activityTags.includes(activity_tag_option.original_item)}
                    />
                    { activity_tag_option.label }
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </Typography>
      </Box>
    </Grid>
  )
}
